import { DecimalPipe } from "@angular/common";
import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ITplArbetsorder } from "../../models/dtos";
import { TplCalculator } from "../../services/tpl.calculator";
import { TplStateService } from "../../state/tpl-state.service";

@Component({
    selector: "rask-tpl-volym",
    templateUrl: "./tpl-volym.component.html",
    styleUrls: ["./tpl-volym.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DecimalPipe]
})
export class TplVolymComponent implements OnInit, OnDestroy {
    count: number;
    isVaglager: boolean;
    selectedcount: number;
    selectedvolume: number;
    volume: number;

    private readonly ngUnsubscribe$ = new Subject<void>();
    private readonly tplCalculator = inject(TplCalculator);
    private readonly tplStateService = inject(TplStateService);

    private arbetsordrar: ITplArbetsorder[];
    private selectedArbetsordrar: ITplArbetsorder[];
    private selectedHs: number[];
    private selectedMottagningsplatser: number[];
    private throttle: any;
    private throttleSel: any;

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit(): void {
        this.registerEventListeners();
    }

    private registerEventListeners() {
        this.tplStateService.current.currentArbetsordrar
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(arbetsordrar => {
                this.arbetsordrar = arbetsordrar;
                this.updateVolym();
            });

        this.tplStateService.current.selected
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(selected => {
                this.selectedArbetsordrar = this.arbetsordrar.filter(x => selected.selected.some(x1 => x1 === x.id));
                this.updateSelectedVolym();
            });

        this.tplStateService.current.selectedHs
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(hs => {
                this.selectedHs = hs;
                this.updateVolym();
            });

        this.tplStateService.current.selectedMottagningsplatser
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(mpls => {
                this.selectedMottagningsplatser = mpls;
                this.updateVolym();
            });

        this.tplStateService.current.destineringHs
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(hs => {
                if (ObjectUtils.hasValue(hs)) {
                    this.selectedHs = [hs];
                } else {
                    this.selectedHs = this.tplStateService.current.getSelectedHandelssortiment();
                }
                this.updateVolym();
            });

        this.tplStateService.current.selectedVaglager
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(vaglager => {
                this.isVaglager = vaglager;
                this.updateVolym();
            });
    }

    private update(arbetsorderList: ITplArbetsorder[], callback: (volume, count) => void = null) {
        if (!arbetsorderList) {
            return;
        }

        const volym = this.tplCalculator.sumHandelssortimentVolym(arbetsorderList, this.isVaglager, this.selectedHs, this.selectedMottagningsplatser);
        callback(volym, arbetsorderList.length);
    }

    private updateSelectedVolym() {
        if (this.throttleSel !== undefined) {
            clearTimeout(this.throttleSel);
        }
        this.throttleSel = setTimeout(() => {
            this.update(this.selectedArbetsordrar, (v, c) => {
                this.selectedvolume = v;
                this.selectedcount = c;
            });
        }, 10);
    }

    private updateVolym() {
        if (this.throttle !== undefined) {
            clearTimeout(this.throttle);
        }
        this.throttle = setTimeout(() => {
            this.update(this.arbetsordrar, (v, c) => {
                this.volume = v;
                this.count = c;
            });
        }, 10);
    }
}
